import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { every } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListUl } from '@fortawesome/pro-solid-svg-icons';

import { Button } from 'components/ui/button';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import TaskList from 'components/tasks/task_list';
import Filters from './filters';

import { toggleSelectAllTasks } from './store/actions/select_list';

import {
  addTask,
  deleteTask,
  toggleTaskState,
  updateTask
} from './store/actions/tasks';
import { getCurrentCallList, sortTasksById } from './store/selectors/search';

export class CallList extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.arrayOf(PropTypes.array),
    callList: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired,
    currentUser: PropTypes.shape({
      id: PropTypes.number
    }).isRequired,
    databaseMembers: PropTypes.array.isRequired,
    filterButtons: PropTypes.array.isRequired,
    newCallButtonText: PropTypes.string.isRequired,
    newCallButtonClick: PropTypes.func.isRequired,
    selectedIds: PropTypes.array.isRequired,
    tasks: PropTypes.array.isRequired,
    onDeleteTask: PropTypes.func.isRequired,
    onSaveTask: PropTypes.func.isRequired,
    onTaskCompletionChange: PropTypes.func.isRequired,
    onToggleSelectAll: PropTypes.func.isRequired,
    onUpdateTask: PropTypes.func.isRequired
  };

  isSelected(taskId) {
    const { selectedIds } = this.props;
    return selectedIds.indexOf(taskId) > -1;
  }

  allSelected() {
    const { tasks } = this.props;
    return every(tasks, call => this.isSelected(call.id));
  }

  render() {
    const { filterButtons,  callList, tasks } = this.props;

    return (
      <React.Fragment>
        <Filters
          additionalActions={filterButtons}
          assigneeLabel="Assignee"
          creatorLabel="Creator"
          hideLabels
          hideSearchTextFilter
          hideTaskTypeFilter
          name={`filters-for-call-list-${callList.id}`}
        />
        {tasks.length > 0
          ? this.renderTaskList()
          : this.renderNoTasks()
        }
      </React.Fragment>
    );
  }

  renderNoTasks() {
    const { newCallButtonText, newCallButtonClick } = this.props;

    return (
      <Empty className="bg-white">
        <Empty.Media>
          <FontAwesomeIcon icon={faListUl} />
        </Empty.Media>
        <Empty.Title>This queue is empty</Empty.Title>
        {newCallButtonText && newCallButtonClick && (
          <Empty.Actions>
            <Button label={newCallButtonText} variant="ghost" onClick={newCallButtonClick} />
          </Empty.Actions>
        )}
      </Empty>
    );
  }

  renderTaskListHeader() {
    const { onToggleSelectAll } = this.props;

    return (
      <tr>
        <th key="select-all">
          <input
            checked={this.allSelected()}
            className="checkbox--lg"
            name="select-all-button"
            type="checkbox"
            onChange={onToggleSelectAll}
          />
        </th>
        <th>{/* Completion checkbox */}</th>
        <th>Name</th>
        <th>{/* Preview button */}</th>
        <th>Company</th>
        <th>{/* Preview button */}</th>
        <th>Details</th>
        <th>Associated With</th>
        <th>Creator</th>
        <th>Assignee</th>
        <th>Due Date</th>
        <th> {/* Action button */} </th>
      </tr>
    );
  }

  renderTaskList() {
    const {
      availableDatabases,
      callList,
      currentUser,
      databaseMembers,
      newCallButtonClick,
      newCallButtonText,
      tasks,
      onDeleteTask,
      onTaskCompletionChange,
      onUpdateTask,
      onSaveTask,
    } = this.props;

    return (
      <>
        <div className="table-container" name="tasks-table">
          <table className="table table-hover">
            <thead>
              {this.renderTaskListHeader()}
            </thead>
            <tbody>
              <TaskList
                availableDatabases={availableDatabases}
                callList={callList}
                databaseMembers={databaseMembers}
                isFromCallList
                multipleProjectsInTask={true}
                selectedId={currentUser.id}
                tasks={tasks}
                onDeleteTask={onDeleteTask}
                onSaveTask={onSaveTask}
                onToggleTaskState={onTaskCompletionChange}
                onUpdateTask={onUpdateTask}
              />
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-end mt-3">
          <button className="btn btn-primary" onClick={newCallButtonClick}>{newCallButtonText}</button>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  availableDatabases: state.static.availableDatabases,
  callList: getCurrentCallList(state),
  currentUser: state.static.currentUser,
  tasks: sortTasksById(state),
  databaseMembers: state.static.databaseMembers,
  selectedIds: state.selectList.selectedTaskIds
});

const mapDispatchToProps = {
  onSaveTask: addTask,
  onDeleteTask: deleteTask,
  onTaskCompletionChange: toggleTaskState,
  onToggleSelectAll: toggleSelectAllTasks,
  onUpdateTask: updateTask
};

export default connect(mapStateToProps, mapDispatchToProps)(CallList);
